import React, { Component } from 'react';
import PropTypes from 'prop-types';
import pure from 'recompose/pure';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import DashboardIcon from 'material-ui/svg-icons/action/dashboard';

import compose from 'recompose/compose';
import { List, ListItem, makeSelectable } from 'material-ui/List';
import BusinessIcon from 'material-ui/svg-icons/communication/business';
import AccountIcon from 'material-ui/svg-icons/action/account-circle';
import SupervisorAccountIcon from 'material-ui/svg-icons/action/supervisor-account';
import DiningIcon from 'material-ui/svg-icons/maps/local-dining';
import Redeem from 'material-ui/svg-icons/action/redeem';
import Announcement from 'material-ui/svg-icons/action/announcement';
import Alarm from 'material-ui/svg-icons/action/alarm';
import Payment from 'material-ui/svg-icons/action/payment';

import { SubsResources, SubsCustomRoutes } from 'routes/subscription';
import { AdminUserResources, AdminUserCustomRoutes } from 'routes/user';
import { ShopResources, ShopCustomRoutes } from 'routes/shop';
import { ProductResources, ProductCustomRoutes } from 'routes/product';
import { NewsResources, NewsCustomRoutes } from 'routes/news';
import { NotificationResources, NotificationCustomRoutes } from 'routes/notification';
import { AdvancedFunctionResources, AdvancedFunctionCustomRoutes } from 'routes/advancedFunction';
import { EPaymentResources, EPaymentCustomRoutes } from 'routes/e_payment';

import { URL_WHITELIST } from 'config';

const SelectableList = makeSelectable(List);

const styles = {
  main: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    height: '100%',
  },
};

const getMenuItems = (resources, customRoutes) => {
  const combineItems = resources.concat(customRoutes);
  return combineItems && combineItems
    .filter(r => r.showInSideMenu && URL_WHITELIST.has(r.frontendPath))
    .map((r, index) =>
      <ListItem primaryText={r.name} value={r.frontendPath}/>);

};

const SubscriptionItems = getMenuItems(SubsResources, SubsCustomRoutes);
const AdminUserItems = getMenuItems(AdminUserResources, AdminUserCustomRoutes);
const ShopItems = getMenuItems(ShopResources, ShopCustomRoutes);
const ProductItems = getMenuItems(ProductResources, ProductCustomRoutes);
const NewsItems = getMenuItems(NewsResources, NewsCustomRoutes);
const NotificationItems = getMenuItems(NotificationResources, NotificationCustomRoutes);
const AdvancedFunctionItems = getMenuItems(AdvancedFunctionResources, AdvancedFunctionCustomRoutes);
const EPaymentCustomItems = getMenuItems(EPaymentResources, EPaymentCustomRoutes);

class Menu extends Component {
  handleChangeList = (event, value) => {
    if (value) {
      this.props.push(value);
    }
  };

  render() {
    const { logout, path } = this.props;
    return (
      <div style={styles.main}>
        <SelectableList
          value={path}
          onChange={this.handleChangeList}
        >
          <ListItem
            leftIcon={<DashboardIcon/>}
            primaryText="Dashboard"
            value="/"
          />
          {ShopItems.length ? <ListItem
            leftIcon={<DiningIcon/>}
            primaryText="Shop"
            primaryTogglesNestedList={true}
            nestedItems={ShopItems}
          /> : null}
          {SubscriptionItems.length ? <ListItem
            leftIcon={<BusinessIcon/>}
            primaryText="Subscription"
            primaryTogglesNestedList={true}
            nestedItems={SubscriptionItems}
          /> : null}
          {ProductItems.length ? <ListItem
            leftIcon={<Redeem/>}
            primaryText="Payment"
            primaryTogglesNestedList={true}
            nestedItems={ProductItems}
          /> : null}
          {EPaymentCustomItems.length ? <ListItem
            leftIcon={<Payment/>}
            primaryText="E-Payment"
            primaryTogglesNestedList={true}
            nestedItems={EPaymentCustomItems}
          /> : null}
          {NewsItems.length ? <ListItem
            leftIcon={<Announcement/>}
            primaryText="News"
            primaryTogglesNestedList={true}
            nestedItems={NewsItems}
          /> : null}
          {NotificationItems.length ? <ListItem
            leftIcon={<Alarm/>}
            primaryText="Notification"
            primaryTogglesNestedList={true}
            nestedItems={NotificationItems}
          /> : null}
          {AdminUserItems.length ? <ListItem
            leftIcon={<AccountIcon/>}
            primaryText="Admin User"
            primaryTogglesNestedList={true}
            nestedItems={AdminUserItems}
          /> : null}
          {AdvancedFunctionItems.length ? <ListItem
            leftIcon={<SupervisorAccountIcon/>}
            primaryText="Advanced Function"
            primaryTogglesNestedList={true}
            nestedItems={AdvancedFunctionItems}
          /> : null}

        </SelectableList>
        {logout}
      </div>
    );
  }
}

Menu.propTypes = {
  logout: PropTypes.element,
  customRoutes: PropTypes.array,
  resources: PropTypes.array,
  handleChangeList: PropTypes.func,
};

const mapStateToProps = (state, props) => ({
  path: state.routing.location.pathname,
});

const enhance = compose(
  pure,
  connect(mapStateToProps, {
    push,
  })
);

export default enhance(Menu);



// WEBPACK FOOTER //
// ./src/components/layout/Menu.js